import { Box, Image, Pressable } from 'native-base';
import React from 'react';
import { ImageStyle } from 'react-native-web';
import { Caption } from '~/shared/Typography';
import { useShopStyles } from '~/shared/styles';
import { Brand, useDutchieStore } from '@springbig/shared';

export type BrandsCardProps = {
    brand: Brand;
    onSelectBrand?: () => void;
};

type ExtendedImageStyle = ImageStyle & { clipPath?: string };

const ImageStyles: ExtendedImageStyle = {
    clipPath: 'circle(40%)',
};

export const BrandsCard = ({
    brand,
    onSelectBrand,
}: BrandsCardProps) => {

    const { pressable_text, button_background, section_background } = useShopStyles();
    const { isBusy } = useDutchieStore();

    return (
        <Pressable
            opacity={isBusy ? .7 : 1}
            isDisabled={isBusy}
            onPress={onSelectBrand}
        >
            { brand.imageUrl ?
                <Image
                    src={brand.imageUrl + '?w=130&h=130'}
                    w={'130px'}
                    h={'130px'}
                    resizeMode={'cover'}
                    style={ImageStyles}
                />
                :
                <Box
                    mx={4}
                    alignItems={'center'}
                    justifyContent={'center'}
                    w={'96px'}
                    h={'96px'}
                    borderRadius={'100px'}
                    borderWidth={3}
                    borderColor={button_background}
                    bg={section_background}
                    my={'auto'}
                >
                    <Caption
                        px={1}
                        noOfLines={2}
                        fontSize={14}
                        fontWeight={600}
                        color={pressable_text}
                        textAlign={'center'}
                    >
                        { brand.name }
                    </Caption>
                </Box>
            }
        </Pressable>
    );
};
